import config from 'config';

class appRouter {

  /**
   * Returns the app root path based on your app type
   * @returns {string}
   */
  static getApplicationPath() {
    return config.application.path;
  }

  /**
   * Returns the route based on your app type
   * @param alias (string)
   * @returns {string}
   */
  static getLink(alias, isExternal) {
    let route = (config.application.routes[alias]) ? config.application.routes[alias] : config.application.routes['home'];
    return (!isExternal ? this.getApplicationPath() : '') + route;
  }

  /**
  * Send Ga Page View
  * @param alias
  */
  static gaPageView(alias) {
    const page = '/' + alias;
    if (ga) {
      ga('send', 'pageview', page);
    }
  }
}

export default appRouter;



// WEBPACK FOOTER //
// ./src/utils/appRouter.js